import { OnInit } from '@angular/core';
var IconComponent = /** @class */ (function () {
    function IconComponent() {
    }
    IconComponent.prototype.ngOnInit = function () {
        this.iconSvgStr = require("./icons/" + this.icon + ".svg");
    };
    return IconComponent;
}());
export { IconComponent };
//# sourceMappingURL=icon.component.js.map